import KeywordInterest from './keywordinterest.vue'
export default KeywordInterest
